import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function LoginPage(): JSX.Element {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function onSignIn(e: React.FormEvent): Promise<void> {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await signIn(email.trim().toLowerCase(), password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-12 bg-black">
      <div className="w-full max-w-md">
        {/* Branding */}
        <div className="flex flex-col items-center mb-8">
          <img src="/CompanyLogo.png" alt="NeoSigma" className="w-16 h-16 rounded-xl mb-4" />
          <h1 className="text-3xl font-bold text-white tracking-tight">
            NeoSigma <span className="text-red-500">Portal</span>
          </h1>
          <p className="text-gray-500 mt-2 text-sm">Sign in to manage issues for your property</p>
        </div>

        <div className="card">
          <form onSubmit={onSignIn} className="space-y-4">
            <div>
              <label className="label" htmlFor="login-email">Email</label>
              <input
                id="login-email"
                className="input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="username"
                required
              />
            </div>
            <div>
              <label className="label" htmlFor="login-password">Password</label>
              <input
                id="login-password"
                className="input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
            </div>

            {error && <div className="text-sm text-red-400">{error}</div>}

            <button
              type="submit"
              className="btn-primary w-full"
              disabled={loading || !email || !password}
            >
              {loading ? 'Signing in…' : 'Sign in'}
            </button>

            <div className="pt-3 border-t border-gray-800 text-sm text-gray-500 space-y-1.5">
              <p>
                New here?{' '}
                <Link to="/signup" className="text-red-400 hover:text-red-300 hover:underline">
                  Create an account
                </Link>
              </p>
              <p>
                <Link to="/forgot-password" className="text-red-400 hover:text-red-300 hover:underline">
                  Forgot password?
                </Link>
              </p>
              <p>
                Didn&rsquo;t receive your verification code?{' '}
                <Link to="/verify-email" className="text-red-400 hover:text-red-300 hover:underline">
                  Enter it here
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
